import React, {useState} from "react";
import { Trash, Search } from "react-bootstrap-icons";

import Options from "components/Options";
import List from "./help/List";
import GroupedList from "./help/GroupedList";

import { groupByGroups } from 'services/groups';
import { useLocalStorage } from "utils/storage";

const TagsSelectCard = ({
    selectedItems = [],
    settings = {},
    
    onSettingChange,
    onItemRemove,
    onSave,
    onCancel
}) => {
    const [tags] = useLocalStorage('tags', []);
    const [search, setSearch] = useState('');

    const listType = settings?.items?.displayGroups?.checked ? 'grouped' : 'default';

    const [checkedUids, setCheckedUids] = useState(
        () => new Set(selectedItems.map(item => item.uid))
    );

    const modifiedTags = tags.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    ).map(tag => ({
        ...tag,
        selected: checkedUids.has(tag.uid)
    }));

    const handleToggle = (uid) => {
        setCheckedUids(prev => {
            const next = new Set(prev);
            next.has(uid) ? next.delete(uid) : next.add(uid);
            return next;
        });
    };

    const handleSave = () => {
        const selected = tags.filter(item => checkedUids.has(item.uid));
        onSave('tag', selected);
    };


    const renderList = (listType) => {
        switch (listType) {
            case 'grouped':
                return (
                    <GroupedList
                        items={groupByGroups(modifiedTags)}
                        onSelect={handleToggle}
                    />
                );
            default:
                return (
                    <List
                        items={modifiedTags}
                        onSelect={handleToggle}
                        // onRemove
                    />
                );
        }
    }


    return (
        <div className="card container-height">

            <div className="card-header form-card-header-paddings no-background no-border">
                <div 
                    className="d-flex justify-content-between align-items-center"
                    style={{
                        padding: '8px 0px 8px 8px'
                    }}
                >
                    <h3>Tags</h3>

                    <Options
                        settings={settings}
                        onChangeHandler={onSettingChange}
                    />
                </div>
            </div>

            <div className="card-body form-card-body-paddings overflow-auto">
                <div className="flex-grow-1 overflow-auto">
                    {renderList(listType)}
                </div>

                
            </div>

            <div className="input-group mt-2 mb-2 d-flex">
                <span className="input-group-text themed-text">
                    <Search size={18} className="themed-text" />
                </span>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search tags"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>

            <div className="card-footer form-card-footer-paddings border-top no-background">
                <div className="d-flex justify-content-between">
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleSave}
                    >
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TagsSelectCard;